module.exports = __webpack_public_path__ + "9e911c68b683bfce45bb6effc5403b1d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-MediumItalic.ttf
// module id = 1259
// module chunks = 0